module.exports = __webpack_public_path__ + "static/media/vf.822ab1d1.png";